module.exports = __webpack_public_path__ + "static/media/rm-background.77bd36ae.jpg";